import { Badge, Box, Flex, Text, Tooltip } from '@chakra-ui/react';

import {
  faTriangleExclamation,
  faShieldCheck
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EMAIL_DELIVERY_STATUS_MAP } from '@publishing-engine/domain/models';
import {
  EMAIL_DELIVERY_ICON_MAP,
  EmailDeliveryStatus,
  emailStatusTooltipMap,
  formatLocalTimestamp
} from './EmailView';
type UserEmailViewProps = {
  email: string;
  isEmailDelivered: boolean | undefined;
  lastSentStatus?: string | undefined;
  timeStamp?: string | number | undefined;
  emailType?: string;
  enableIcon: boolean;
  isUserDeactivated?: boolean;
};

const UserEmail: React.FC<UserEmailViewProps> = ({
  email,
  isEmailDelivered,
  lastSentStatus,
  timeStamp,
  emailType,
  enableIcon,
  isUserDeactivated = false
}) => {
  const deliveryIcon = lastSentStatus
    ? EMAIL_DELIVERY_ICON_MAP[lastSentStatus as EmailDeliveryStatus]
    : undefined;
  const deliveryIconColor = lastSentStatus
    ? EMAIL_DELIVERY_STATUS_MAP[lastSentStatus as EmailDeliveryStatus]
    : undefined;
  const lastSentEmailTimeFormatted = timeStamp
    ? formatLocalTimestamp(Number(timeStamp) * 1000)
    : undefined;
  const emailStatusTooltip = lastSentStatus
    ? emailStatusTooltipMap[lastSentStatus]
    : undefined;
  return (
    <Flex gap={2} alignItems="center">
      {email && (
        <Text textStyle="textBody" mt="-1">
          {emailType && (
            <Box as="span" textStyle="headingItem">
              {emailType}:
            </Box>
          )}{' '}
          <Box as="span" wordBreak={'break-word'}>
            {email}
          </Box>
          {isUserDeactivated === false && (
            <>
              {enableIcon && (
                <Tooltip
                  placement="top"
                  label={
                    isEmailDelivered ? 'Email verified' : 'Email Unverified'
                  }
                  shouldWrapChildren
                >
                  <Badge
                    ml={1}
                    p={1}
                    lineHeight={'normal'}
                    variant={isEmailDelivered ? 'success' : 'attention'}
                  >
                    <FontAwesomeIcon
                      icon={
                        isEmailDelivered ? faShieldCheck : faTriangleExclamation
                      }
                    />
                  </Badge>
                </Tooltip>
              )}

              {lastSentStatus && deliveryIcon && (
                <Tooltip
                  placement="top"
                  label={`${emailStatusTooltip}: ${lastSentEmailTimeFormatted}`}
                  shouldWrapChildren
                >
                  <Badge
                    ml={1}
                    lineHeight={'normal'}
                    variant={deliveryIconColor}
                    p={1}
                  >
                    <FontAwesomeIcon icon={deliveryIcon} />
                  </Badge>
                </Tooltip>
              )}
            </>
          )}
        </Text>
      )}
    </Flex>
  );
};

export default UserEmail;
